import SquareMonoTeal from '~/brand/generated/propfit.app/SquareMonoTeal';

interface PropfitAvatarProps {
  className?: string;
}

export function PropfitAvatar({ className = '' }: PropfitAvatarProps) {
  return (
    <div
      className={
        'flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-sm ' +
        className
      }
    >
      <SquareMonoTeal className='h-7 w-7' />
    </div>
  );
}
